import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Media } from "src/app/models/media";
import { ApplicationPool } from "src/app/services/application.pool";
import { ActionService } from "src/app/services/action.service";
import { styles } from "../printing-styles";
import { Library } from "src/app/models/library";
import { EmptyPageService } from "src/app/services/empty-page.service";

@Component({
  selector: "app-print-media-barcodes",
  templateUrl: "./print-media-barcodes.component.html",
  styles
})
export class PrintMediaBarcodesComponent implements OnInit {
  @ViewChild("content") private contentRef: ElementRef;

  private ids: number[] = [];
  private print: boolean = true;
  private alreadySetPresent = false;
  private href: string = null;

  public blankBarcodes: number[] = [];

  private get Library(): Library {
    return this.dataPool.Library;
  }

  public get UseMediaSignature(): boolean {
    return (
      this.Library.configuration.useBarcodeSignature && !this.skipSignature
    );
  }

  public get Medias(): Media[] {
    if (this.dataPool.Medias) {
      const medias = this.dataPool.Medias.filter(
        (m) => this.ids.filter((id) => m.id == id).length > 0
      );
      if (!this.alreadySetPresent) {
        this.alreadySetPresent = true;
        medias.forEach((m) => {
          this.dataService.setMediaPresent(m);
        });
      }
      if (this.print) {
        this.print = false;
        const t = this;
        setTimeout(() => {
          this.emptyPageService.render(
            `<html moznomarginboxes mozdisallowselectionprint class="${this.Library.configuration.optimizeLabelsForThermalTransfer ? "thermal-transfer-optimized" : ""}"><head><style>${styles[0]} @page { margin-top: ${t.MarginTop}; margin-left: ${t.MarginLeft}; margin-right: 0px; margin-bottom:0px;} media-barcode, media-signature {page-break-inside: avoid;width: ${t.Width}; height: ${t.Height};}
             div.signature {
              text-align: center;
              display: table!important;
              height:100%;
              font-size: 25px !important;
              line-height: 30px; 
              float:left;
            }
            div.signature>div {
              display:table-cell;
              vertical-align:middle;
            }
            div.signature * {
              font-size: 14px !important;
              line-height: 20px;
            }
            div.signature .id {font-size:90%}
            body {margin:0px;}
            .thermal-transfer-optimized * {font-family: "Arial" !important; font-weight: 600;} 
            .thermal-transfer-optimized .sign {font-weight: 800;}
            </style></head><body>${t.contentRef.nativeElement.innerHTML}</body></html>`
          );
          setTimeout(() => {
            this.emptyPageService.print();
          }, 200);

          if (this.href) {
            this.router.navigate([this.href.replace(/\%2F/gi, "/")]);
          } else if (this.newElement) {
            this.router.navigate(["/media/new"]);
          } else {
            this.router.navigate(["/media/barcode"]);
          }
        }, 50);
      }
      return medias;
    }
  }

  private get Width(): string {
    if (this.Library) {
      return `${this.Library.configuration.barcodeDimensions.width}cm`;
    }
  }

  private get Height(): string {
    if (this.Library) {
      return `${this.Library.configuration.barcodeDimensions.height * 1}cm`;
    }
  }

  private get MarginLeft(): string {
    if (this.Library) {
      return `${this.Library.configuration.barcodeDimensions.sheetMarginLeft}cm`;
    }
  }

  private get MarginTop(): string {
    if (this.Library) {
      return `${this.Library.configuration.barcodeDimensions.sheetMarginTop}cm`;
    }
  }

  private newElement: boolean = false;

  private skipSignature = false;

  constructor(
    private route: ActivatedRoute,
    private dataPool: ApplicationPool,
    private dataService: ActionService,
    private router: Router,
    private emptyPageService: EmptyPageService
  ) {
    this.route.params.subscribe((params: any[]) => {
      const val = JSON.parse(params["val"]);
      this.ids = val.media;
      this.href = val.href;
      this.skipSignature = val.skipSignature;
      const blank: any = val.blankBarcodes;
      if (val.new) this.newElement = true;
      if (blank) {
        let blankBarcodesCount = +blank;
        while (blankBarcodesCount-- > 0) {
          this.blankBarcodes.push(0);
        }
      }
    });
  }

  ngOnInit(): void {}

  get signatureColorRectangle() {
    return (
      this.dataPool.Library.configuration?.printSignatureRectangle || false
    );
  }
}
